import React, { useState, useContext } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	useMediaQuery,
	Slide,
	Grid,
	useTheme,
	makeStyles,
	IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useForm } from "react-hook-form";
import { userServices } from "../services";
import { AuthContext } from "../context";
import { TextField } from "./";
const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditUser(props) {
	const theme = useTheme();
	const classes = useStyles();
	const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const { register, handleSubmit, errors } = useForm();
	const { authState } = useContext(AuthContext);
	const [user] = useState(props.user);

	const editOperator = async (dataToEdit) => {
		const user = {
			username: dataToEdit.username,
			email: dataToEdit.email,
		};
		try {
			const { status, response } = await userServices.updateUser({ _id: props.user._id, user, token: authState.token });
			switch (status) {
				case 200:
					if (response.error) {
						props.toast(response.error.message, true);
					} else {
						props.close();
						props.toast("Usuario actualizado con exito", true);
						props.reload();
					}
					break;
				case 400:
					props.toast(response.error.message, true);
					break;
				default:
					break;
			}
		} catch (e) {
			console.log(e);
		}
	};

	return (
		<Dialog
			PaperProps={{ style: { borderRadius: 45 } }}
			maxWidth="sm"
			fullScreen={fullScreen}
			open={props.open}
			TransitionComponent={Transition}
		>
			<IconButton aria-label="close" className={classes.closeButton} onClick={props.close}>
				<CloseIcon />
			</IconButton>
			<DialogTitle className={classes.dialogTitle}>Editar administrador</DialogTitle>
			<DialogContent>
				<form className={classes.form} onSubmit={handleSubmit(editOperator)}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={12}>
							<TextField
								variant="outlined"
								fullWidth
								id="username"
								placeholder="Usuario *"
								name="username"
								type="username"
								autoComplete="username"
								defaultValue={user.username}
								size="small"
								inputRef={register({
									required: "Usuario requerido",
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.username ? true : false}
								helperText={errors.username ? errors.username.message : ""}
							/>
						</Grid>

						<Grid item xs={12} sm={12}>
							<TextField
								variant="outlined"
								fullWidth
								id="email"
								placeholder="Correo electrónico *"
								name="email"
								size="small"
								autoComplete="email"
								defaultValue={user.email}
								inputRef={register({
									required: "Correo requerido",
									pattern: {
										value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
										message: "Formato de correo inválido",
									},
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.email ? true : false}
								helperText={errors.email ? errors.email.message : ""}
							/>
						</Grid>
					</Grid>
					<DialogActions>
						<Button
							type="submit"
							fullWidth
							size="small"
							variant="contained"
							color="secondary"
							className={classes.submit}
							style={{ textTransform: "capitalize", borderRadius: "20px" }}
						>
							Guardar
						</Button>
					</DialogActions>
				</form>
			</DialogContent>
		</Dialog>
	);
}

const useStyles = makeStyles((theme) => ({
	form: {
		marginTop: theme.spacing(2),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
	textField: {
		width: "100%",
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(2),
		top: theme.spacing(2),
		color: "#FFF",
		backgroundColor: theme.palette.secondary.main,
		width: 30,
		height: 30,
		"&:hover": {
			backgroundColor: theme.palette.secondary.main,
		},
	},
	dialogTitle: {
		textAlign: "left",
		color: theme.palette.primary.main,
		"& h2": {
			fontWeight: "bold",
		},
	},
}));
